import './DialogContent.css'

export default function DialogContent(props) {
  const { content } = props
  return <div className="dialog-content">{content}</div>
}
